<template>
    <div v-show="state && state.results">
        <div v-for="(filter, index) in filters">
            <RefinementList
                v-if="filter.filter_type === 'refinementList'"
                :key="index"
                :attribute="filter.attribute_name"
                :label="filter.filter_header"
                :limit="filter.limit"
                :is-open="true"
            />
            <RefinementListSlider
                v-if="filter.filter_type === 'refinementListSlider'"
                :key="index"
                :attribute="filter.attribute_name"
                :label="filter.filter_header"
                :is-open="true"
            />
            <RefinementListStars
                v-if="filter.filter_type === 'refinementListStars'"
                :key="index"
                :attribute="filter.attribute_name"
                :label="filter.filter_header"
                :is-open="true"
            />
        </div>
    </div>
</template>

<script>
import RefinementList from "./RefinementList";
import RefinementListSlider from "./RefinementListSlider";
import RefinementListStars from "./RefinementListStars";
import { connectHits } from 'instantsearch.js/es/connectors';
import { createWidgetMixin } from 'vue-instantsearch/vue3/es';

export default {
    name: "FilterPanel",
    components: {
        RefinementList,
        RefinementListSlider,
        RefinementListStars
    },
    props: {
        filters: {
            type: Array,
            required: true,
        }
    },
    mixins: [createWidgetMixin({ connector: connectHits })]
};
</script>
